<template>
<div id="list-client-pagee" class="data-list-container">
    <vs-table ref="table" v-model="selectedClient" pagination :max-items="itemsPerPage" search :data="dataList">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                <!-- ACTION - DROPDOWN -->
                <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">
                    <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
                        <span class="mr-2">Actions</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="$refs.myPdfComponent.print()">
                            <span class="flex items-center">
                                <feather-icon icon="PrinterIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Imprimer</span>
                            </span>
                        </vs-dropdown-item>

                        <vs-dropdown-item @click="exportToExcel">
                            <span class="flex items-center">
                                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Exporter Excel</span>
                            </span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="exportToCsv">
                            <span class="flex items-center">
                                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Exporter Csv</span>
                            </span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="exportToTxt">
                            <span class="flex items-center">
                                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Exporter Txt</span>
                            </span>
                        </vs-dropdown-item>

                        <!-- <vs-dropdown-item>
                            <span class="flex items-center">
                                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Archiver</span>
                            </span>
              </vs-dropdown-item>-->
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ dataList.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : dataList.length }} of {{ queriedItems }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemsPerPage=7">
                        <span>7</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=15">
                        <span>15</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=25">
                        <span>25</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=35">
                        <span>35</span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
        </div>

        <template slot="thead">
            <vs-th sort-key="Item_No" class="table_head_color">Code</vs-th>
            <vs-th sort-key="Name" class="table_head_color">Nom</vs-th>
            <vs-th sort-key="Year" class="table_head_color">Téléphone</vs-th>
            <vs-th sort-key="Year" class="table_head_color">Type</vs-th>
            <vs-th sort-key="Year" class="table_head_color">Magazin</vs-th>

            <vs-th sort-key="Year" class="table_head_color">Actions</vs-th>
        </template>

        <template slot-scope="{data}">
            <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].No">
                        <p class="product-name font-medium truncate">{{ tr.No }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.First_Name }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.Phone_No }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.Type}}</p>
                    </vs-td>
                    <vs-td>
                        <p>{{ tr.Responsibility_Center}}</p>
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                        <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
                        <img v-if="tr.Portal_Status==' '" key="onlineImg1" :src="imgUpdate" alt="user-img" width="18" height="18" class="ml-2" @click.stop="onClientSelectModif(tr)" />
                        <img v-if="tr.Portal_Status=='Actif' || tr.Portal_Status=='Non Actif'" key="onlineImg2" :src="imgpwd" alt="user-img" width="18" height="18" class="ml-2" @click.stop="updatePassword(tr)" />
                        <img v-if="tr.Portal_Status=='Actif'" key="onlineImg3" :src="imgRemove" alt="user-img" width="18" height="18" class="ml-3" @click.stop="desactiverCompte(tr)" />
                        <img v-if="tr.Portal_Status=='Non Actif'" key="onlineImg4" :src="imgActiv" alt="user-img" width="18" height="18" class="ml-3" @click.stop="ActiverCompte(tr)" />
                    </vs-td>
                </vs-tr>
            </tbody>
        </template>
    </vs-table>

    <!-- <pdf v-show="shadowpdf" ref="myPdfComponent" :src="baseUrl"></pdf> -->
</div>
</template>

<script>
import pdf from "vue-pdf";
import index from "@/http/requests/admin/index.js";
import jwtService from "@/http/requests/auth/jwt/index.js";

//import service from "./dashboardService.js";
export default {
    components: {
        pdf
    },
    data() {
        return {
            itemsPerPage: 10,
            currentPage: 1,
            baseUrl: "",
            active: false,
            dialog: false,
            popupActiAdd: false,
            showChart: false,
            colorx: this.$store.state.themePrimaryColor,
            popupActivo5: false,
            showdata: false,
            selectedClient: null,
            dataList: [],
            queriedItems: 0,
            shadowpdf: false,
            cellAutoWidth: true,
            headerTitle: [
                "N° Livreur",
                "Nom",
                "Telephone",
                "Type",
                "Magasin",

            ],
            headerVal: ["No", "First_Name", "Phone_No", "Type", "Responsibility_Center"],
            imgRemove: require("@/assets/images/portrait/small/remove.png"),
            imgUpdate: require("@/assets/images/portrait/small/update2.png"),
            imgpwd: require("@/assets/images/file-icons/password.png"),
            imgActiv: require("@/assets/images/file-icons/padlock.png")
        };
    },

    methods: {
        ActiverCompte(tr) {
            this.selectedClient = tr;
            this.$vs.dialog({
                type: "confirm",
                color: "warning",
                title: `Activer Compte`,
                text: "Voulez vous activer le compte de " + tr.First_Name,
                acceptText: "Activer",
                cancelText: "Annuler",
                accept: this.onActiverCompte
            });
        },
        onActiverCompte() {
            let comte = {
                username: this.selectedClient.No,
                etat: true,
                role: 'Livreur'
            }
            jwtService.desactiverCompte(comte).then(
                data => {
                    this.selectedClient.Portal_Status = "Actif"
                    const index = this.dataList.findIndex((p) => p.No == this.selectedClient.No)
                    this.dataList[index] = this.selectedClient

                    this.$vs.dialog({
                        type: "confirm",
                        color: "warning",
                        title: `Activation Compte`,
                        text: "La compte de " +
                            this.selectedClient.First_Name +
                            "est : ' " +
                            data.data +
                            " '"
                    });
                },
                err => {
                    this.$swal.fire({
                        position: "absolute",
                        icon: "warning",
                        title: "Erreur : " + err,
                        showConfirmButton: true,
                        timer: 2500
                    });
                }
            );
        },
        updatePassword(tr) {
            this.selectedClient = tr;
            this.$vs.dialog({
                type: "confirm",
                color: "warning",
                title: `Modifier mot de passe `,
                text: "Voulez vous modifier le Mot de passe de " + tr.First_Name,
                acceptText: "modifier",
                cancelText: "Annuler",
                accept: this.onUpdatePassword
            });
        },
        onUpdatePassword() {
            jwtService.updatePassword(this.selectedClient.No).then(
                data => {

                    this.$vs.dialog({
                        type: "confirm",
                        color: "warning",
                        title: `Nouveau mot de passe`,
                        text: "la nouvelle mot de passe de  " +
                            this.selectedClient.First_Name +
                            "est : ' " +
                            data.data +
                            " '"
                    });
                },
                err => {
                    this.$swal.fire({
                        position: "absolute",
                        icon: "warning",
                        title: "Erreur : " + err,
                        showConfirmButton: true,
                        timer: 2500
                    });
                }
            );
        },
        onClientSelectModif(compte) {
            this.selectedClient = compte;
            this.onClientSelect();
        },
        desactiverCompteUser() {
            let comte = {
                username: this.selectedClient.No,
                etat: false,
                role: 'Livreur'
            }

            jwtService.desactiverCompte(comte).then(
                data => {
                    this.selectedClient.Portal_Status = "Non Actif"
                    const index = this.dataList.findIndex((p) => p.No == this.selectedClient.No)
                    this.dataList[index] = this.selectedClient
                    this.$swal.fire({
                        position: "absolute",
                        icon: "warning",
                        title: data.data,
                        showConfirmButton: true,
                        timer: 2500
                    });
                },
                err => {
                    this.$swal.fire({
                        position: "absolute",
                        icon: "warning",
                        title: "Error" + err,
                        showConfirmButton: true,
                        timer: 2500
                    });
                }
            );
        },
        desactiverCompte(compte) {

            this.selectedClient = compte;
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Désactiver Compte `,
                text: "Voulez vous désactiver le compte " +
                    compte.First_Name +
                    " de utilisateurs de portail. La désactivation de compte empêche cet utilisateur d'acceder au portail.",
                acceptText: "Désactiver",
                cancelText: "Annuler",
                cancelColor: "#0000",
                accept: this.desactiverCompteUser
            });
        },
        onClientSelect() {
            // this.selectedClient=tr ;
            this.$vs.dialog({
                type: "confirm",
                color: "primary",
                title: `Ajouter Livreur Portail `,
                text: "Voulez vous ajout " +
                    this.selectedClient.First_Name +
                    " au utilisateurs de portail.",
                acceptText: "Ajouter",
                cancelText: "Annuler",
                accept: this.addClient
            });
        },
        addClient() {
            this.$vs.loading();

            index
                .addLivreurToPort(this.selectedClient)
                .then(data => {
                    this.selectedClient.Portal_Status = "Actif"
                    const index = this.dataList.findIndex((p) => p.No == this.selectedClient.No)
                    this.dataList[index] = this.selectedClient

                    this.$vs.loading.close();
                    this.$swal.fire({
                        position: "absolute",
                        icon: "success",
                        title: data.data,
                        showConfirmButton: true,
                        timer: 2500
                    });
                })
                .catch(error => {

                    this.$vs.loading.close();
                    this.$swal.fire({
                        position: "absolute",
                        icon: "warning",
                        title: error,
                        showConfirmButton: true,
                        timer: 2500
                    });
                });
        },
        exportToExcel() {
            import("@/vendor/Export2Excel").then(excel => {

                const data = this.formatJson(this.headerVal, this.dataList);
                excel.export_json_to_excel({
                    header: this.headerTitle,
                    data,
                    filename: this.fileName,
                    autoWidth: this.cellAutoWidth,
                    bookType: "xlsx"
                });
                //this.clearFields()
            });
        },
        exportToCsv() {
            import("@/vendor/Export2Excel").then(excel => {
                const data = this.formatJson(this.headerVal, this.dataList);
                excel.export_json_to_excel({
                    header: this.headerTitle,
                    data,
                    filename: this.fileName,
                    autoWidth: this.cellAutoWidth,
                    bookType: "csv"
                });
                //this.clearFields()
            });
        },
        exportToTxt() {
            import("@/vendor/Export2Excel").then(excel => {
                const data = this.formatJson(this.headerVal, this.dataList);
                excel.export_json_to_excel({
                    header: this.headerTitle,
                    data,
                    filename: this.fileName,
                    autoWidth: this.cellAutoWidth,
                    bookType: "txt"
                });
                //this.clearFields()
            });
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v =>
                filterVal.map(j => {
                    // Add col name which needs to be translated
                    // if (j === 'timestamp') {
                    //   return parseTime(v[j])
                    // } else {
                    //   return v[j]
                    // }

                    return v[j];
                })
            );
        },
        clearFields() {
            (this.filename = ""),
            (this.cellAutoWidth = true),
            (this.selectedFormat = "xlsx");
        },
        loadData() {
            try {
                this.dataList = JSON.parse(JSON.stringify(this.$store.state.moduleusermanagement.listLivreur));
                this.$vs.loading.close("#list-client-pagee > .con-vs-loading");
            } catch {
                this.$vs.loading.close("#list-client-pagee > .con-vs-loading");
                this.$vs.loading.close();
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la récupération de données",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        }
    },

    created() {
        if (
            this.$store.state.moduleusermanagement.listLivreur != null &&
            this.$store.state.moduleusermanagement.listLivreur.length > 0
        ) {
            this.loadData();
        } else {
            this.$store.subscribe(mutation => {
                if (mutation.type === "moduleusermanagement/UPDATE_LIST_LIVREURS") {
                    this.loadData();
                }
            });
        }
    },
    mounted() {
        this.isMounted = true;
        if (this.$store.state.moduleusermanagement.listLivreur == null || 
        this.$store.state.moduleusermanagement.listLivreur.length == 0) {
            this.$vs.loading({
                background: this.backgroundLoading,
                type: 'radius',
                container: "#list-client-pagee",
                scale: 0.45,
                clickEffect: true
            });
        }
    }
};
</script>

<style lang="scss">
#list-client-pagee {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;

    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .product-name {
        max-width: 23rem;
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }
}
</style>
